import apiRequest from '@/services/api-request.js';
import loggingDevInfo from '@/services/log-dev-info';

export default {
	namespaced: true,
	state: {
    configuration: null,
	},
	mutations: {
    setConfiguration(state, payload) {
      state.configuration = payload;
    },
	},
	actions: {
    fetchFinderConfiguration({state, commit}) {
      if (state.configuration) return;

      return apiRequest(`/wfc/wc-finder.json`, 'get')
        .then((config) => {
          commit('setConfiguration', config);
        })
        .catch((e) => loggingDevInfo(e, 'error'));;
    }
  },
  getters: {
    getFinderConfigurationByContextId: (state) => (contextId) => {
      const config = state?.configuration;

      if (config && config[contextId]) {
        return config[contextId];
      }

      return null;
    },
    getInitialValuesByContextId: (state, getters) => (contextId) => {
      const config = getters.getFinderConfigurationByContextId(contextId);
      if (!config) return null;

      return {
        application: config["application"],
        startingMaterial: config["startingMaterial"],
        analyte: config["analyte"],
        technology: config["analysisType"],
      };
    }
  } 
};
